import { useCallback } from "react"
import { useSelector } from "react-redux"

import { type RootState } from "../../../../store.ts"
import { DATE_FORMAT } from "../../../../utils/date/date.ts"
import { DATE_FORMATS_OBJ } from "../../../TeamManagementPage/constants/date-formats.ts"
import { formatActivityMoment } from "./lead-activity-date.ts"

export const useLeadActivityFormat = () => {
  const timezone = useSelector(
    (state: RootState) => state.auth?.userInfo?.timezone || "UTC"
  )
  const dateFormatId = useSelector(
    (state: RootState) => state.auth?.userInfo?.date_format
  )

  const dateFormat = dateFormatId
    ? (DATE_FORMATS_OBJ[dateFormatId]?.format ?? DATE_FORMAT)
    : DATE_FORMAT

  const formatMoment = useCallback(
    (value: unknown) => formatActivityMoment(value, dateFormat, timezone),
    [dateFormat, timezone]
  )

  return { timezone, dateFormat, formatMoment }
}
